<template>
    <div>
          <div class="mfact-active-color" :style="{ background: color }" v-if="!edit"></div>
      <div v-else-if="isCompColors" >
          <TwitterPicker v-model="colorValue" class="hide-triangle"
          @update:modelValue="updateColor"/>
          <o-modal v-if="isAdvancedColors" :active="isAdvancedColors" :canCancel="false" class="modal-sm">
            <PhotoshopPicker @ok="updateColor" :okLabel="'Apply'" @reset="colorValue = initialColor" :resetLabel="'Undo'"
              @cancel="closeAdvancedColors" :cancelLabel="'Cancel'" :title="moduleLabel" :currentColor="colorValue"
              :hasResetButton="true" v-model="colorValue"/>
          </o-modal>
      </div>
      <div v-else-if="isTagColor">
        <ChromePicker 
          v-model="colorValue" @update:modelValue="updateColor"
        />
      </div>
      <Dropdown v-else :shown="displayPicker">
          <div
          @click="toggle"
          class="mfact-active-color"
          :style="{ background: color }"
          ></div>
          <template #popper>
            <ColorPicker
              theme="light"
              :color="color"
              :sucker-hide="false"
              @changeColor="changeColor"
              />
          <a v-close-popper>Close</a>
          </template>
      </Dropdown>
    </div>
</template>

<script>
import { defineComponent, toRefs, reactive, watch } from 'vue';
import { Dropdown } from 'v-tooltip';
import { ColorPicker } from 'vue-color-kit';
import 'vue-color-kit/dist/vue-color-kit.css';
import { TwitterPicker, PhotoshopPicker, ChromePicker } from 'vue-color';

export default defineComponent({
  name: 'MfactColorPicker',
  components: {
    Dropdown,
    ColorPicker,
    TwitterPicker,
    PhotoshopPicker,
    ChromePicker,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#000000',
    },
    isCompColors: {
      type: Boolean,
      default: false,
    },
    colorValue: {
      type: String,
      default: '#000000',
    },
    moduleLabel: {
      type: String,
      default: '',
    },
    isAdvancedColors: {
      type: Boolean,
      default: false,
    },
    isTagColor: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, { emit }) {
    const colorInitials = reactive({
      displayPicker: false,
      colorValue: props.colorValue,
      displayLabel: props.moduleLabel,
      initialColor: props.colorValue,
    });
    const changeColor = (color) => {
      emit('update:color', color.hex);
    };
    const toggle = () => {
      colorInitials.displayPicker = true;
    };
    const updateColor = (color) => {
      emit('update:color', colorInitials.colorValue);
      emit('close-advanced-colors');
    };

    const closeAdvancedColors = () => {
      emit('close-advanced-colors');
    };

    watch(() => props.colorValue, (newColor) => {
      colorInitials.colorValue = newColor;
    });

    watch(() => props.moduleLabel, (newLabel) => {
      colorInitials.displayLabel = newLabel;
    });

    watch(() => props.isCompColors, (newVal) => {
    if (!newVal) {
      colorInitials.displayPicker = false;
    }
    });

    return {
      ...toRefs(colorInitials),
      toggle,
      changeColor,
      updateColor,
      closeAdvancedColors,
    };
  },
});
</script>
